const secondary = {
    social_bind_with: 'Já tem uma conta? Faça login para agregar {{methods, list(type: disjunction;)}} com a sua identidade social.',
};
export default Object.freeze(secondary);
